import {
  ImportAgendaSlotDoctolibCsvApiPayload,
  ImportAgendaSlotDoctolibCsvApiResponse,
} from '@omecare/utils';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import http from '@/utils/http.service';

type ImportAgendaSlotDoctolibCsvPayload =
  ImportAgendaSlotDoctolibCsvApiPayload & {
    id: string;
  };
const importAgendaSlotDoctolibCsv = (
  payload: ImportAgendaSlotDoctolibCsvPayload,
) => {
  return http.agendaSlots.importDoctolibCsv(payload.id, {
    doctolibFile: payload.doctolibFile,
  });
};

const useImportAgendaSlotDoctolibCsvMutation = (): UseMutationResult<
  ImportAgendaSlotDoctolibCsvApiResponse,
  Error,
  ImportAgendaSlotDoctolibCsvPayload
> => {
  const { t } = useTranslation();
  return useMutation({
    mutationFn: importAgendaSlotDoctolibCsv,
    onSuccess() {
      toast.success(t('http.import-agenda-slot-doctolib-csv.success'));
    },
  });
};

export default useImportAgendaSlotDoctolibCsvMutation;
